export default "/build/images/map-marker-alert-minor-icon.c3dcc6b0.png";